import {
    and,
    collection,
    doc,
    getDocs,
    getFirestore,
    or,
    query,
    setDoc,
    where,
    addDoc,
    updateDoc,
    increment,
    getDoc,
    orderBy,
    arrayUnion
} from "firebase/firestore";
import {app} from "../libs/Firebase";
import {Suspense,useState} from "react";
import {Modal} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import * as url from "url";
import {useForm} from "react-hook-form";
import React from 'react'
import Select from 'react-select'


let executingPromise;
let executingUsersPromise;
const db = getFirestore(app);
const authUserCollectionRef = collection(db, 'users');
const docRef = collection(db,"tournaments");
const id = sessionStorage.getItem('id');
const name = sessionStorage.getItem('name');
const discord = sessionStorage.getItem('discord');
const gameid = sessionStorage.getItem('gameid');
const gameName = sessionStorage.getItem('gamename');
const mode = sessionStorage.getItem('mode');
const entriesRef = collection(db, 'entries/'+id+'/entries');
const tname = sessionStorage.getItem('tname')
const email = localStorage.getItem('email')

const getUsers = async () => {
    const q = query(authUserCollectionRef,where('isVerified' ,'==',true));
    let all = [];
    try {
        const querySnapshot = await getDocs(q);
        querySnapshot.docs.map((doc)=>{
            const data = doc.data();
            if (data["entriesTournament"].indexOf(id) === -1){
                const d = {
                    label: data.discordId,
                    value:data.displayName,
                };
                if (d.value !== name){
                    all.push(d)
                }
            }
            return null;
        })
        return all;
    }catch (error){
        return Promise.reject(error);
    }
}

const getTournament = async () => {
    const q = query(docRef,where('id' ,'==', id));
    let all = [];
    try {
        const querySnapshot = await getDocs(q);
        querySnapshot.docs.map((doc)=>{
            const data = doc.data();
            const d = {
                id:data.id,
                date: data.date,
                entry: data.entry.seconds,
                maxentry: data.maxentry,
                name: data.name,
                description: data.description,
                now:data.now,
                teamSize:data.teamSize,
            };
            all.push(d);
            return d;
        })
        return all;
    }catch (error){
        return Promise.reject(error);
    }
}
const getEntries = async () =>{
    const q = query(entriesRef,where('confirmed', '==', true),orderBy('entryDate', "desc"))
    try{
        const querySnapshot = await getDocs(q);
        const a = querySnapshot.docs.map((value, index) => {
            const data = value.data();
            const date = new Date(data['entryDate']['seconds'] * 1000);
            const y = date.getFullYear();
            const M = date.getMonth() + 1;
            const d = date.getDate();
            const h = date.getHours();
            let m = date.getMinutes();
            return (
                <tr>
                    <td className={"name"}>{data['name']}</td>
                    <td>{y}/{M}/{d} {('0' + h).slice(-2)}:{('0' + m).slice(-2)}</td>
                </tr>
            )
        })
        return(
            <>
                <table>
                    <tbody>
                    <tr>
                        <th>ユーザー名</th>
                        <th>エントリー日時</th>
                    </tr>
                    {a}
                    </tbody>
                </table>
            </>
        )
    }catch (error){
        await Promise.reject(error);
    }
}

class PromiseWrapper {
    #state;

    constructor(promise: Promise) {
        const p = promise.then((result) => {
            this.#state = {
                type: "fulfilled",
                result: result
            };
            return result;
        }).catch((e) => {
            this.#state = {
                type: "rejected",
                error: e
            };
            throw e;
        });
        this.#state ={
            type:"pending",
            promise: p
        };
    }
    get(){
        switch (this.#state.type) {
            case "pending": {
                throw this.#state.promise;
            }
            case "fulfilled": {
                return this.#state.result;
            }
            case "rejected": {
                throw this.#state.error;
            }
        }
    }
}

function fetchData(id) {
    if (!executingPromise) {
        executingPromise = new PromiseWrapper(getTournament(id));
    }
    return executingPromise.get();
}
function fetchTData() {
    if (!executingPromise) {
        executingPromise = new PromiseWrapper(getEntries());
    }
    return executingPromise.get();
}
function fetchUsers(){
    if (!executingUsersPromise){
        executingUsersPromise = new PromiseWrapper(getUsers());
    }
    return executingUsersPromise.get();
}
function SuspendedComponent() {
    const {register , handleSubmit } = useForm();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const users = fetchUsers();
    if (mode === 'joined'){
        const a = fetchTData();
        return (
            <>
                <h1 className="text-center">{tname}</h1>
                {a}
                <Button variant="secondusersary" style={{marginLeft: "auto", marginRight: "auto", display: "block",marginTop: "8px"}} value="戻る"
                        onClick={backHome}>戻る</Button>
            </>
        )
    }else if (mode === 'normal'){
        const data = fetchData(id)[0];
        const date = new Date(data.entry * 1000);
        const y = date.getFullYear();
        const M = date.getMonth() + 1;
        const d = date.getDate();
        const h = date.getHours();
        let m = date.getMinutes();
        let a;
        let b =
            <Button variant="primary" type="submit" onClick={() => {
                handleClose();
                entry(null,null);
            }}>
                同意してエントリー
            </Button>;
        if (data.teamSize !== 1) {
            const f = [...Array(data.teamSize-1)].map((value, index)=> {
                return(
                    <div className="Form-Item">
                        <p className="Form-Item-Label">
                            <span className="Form-Item-Label-Required">必須</span>{index+2}人目のdiscordID
                        </p>
                        {/*<Autosuggest*/}
                        {/*    id={index+2}*/}
                        {/*    suggestions={suggestions}*/}
                        {/*    onSuggestionsFetchRequested={onSuggestionsFetchRequested}*/}
                        {/*    onSuggestionsClearRequested={onSuggestionsClearRequested}*/}
                        {/*    getSuggestionValue={getSuggestionValue}*/}
                        {/*    renderSuggestion={renderSuggestion}*/}
                        {/*    inputProps={inputProps}*/}
                        {/*    {...register('d'+(index+2))}*/}
                        {/*></Autosuggest>*/}
                        <Select options={users} id={'d'+(index+2)}></Select>
                    </div>
                );
            })
            const onSubmit = data => {
                entry(data,data.teamSize)
            }
            a =
                <form className="Form" onSubmit={handleSubmit(onSubmit)}>
                    <div className="Form-Item">
                        <p className="Form-Item-Label">
                            <span className="Form-Item-Label-Required">必須</span>チーム名※公開されます。6文字以内
                        </p>
                        <input type="text" className="Form-Item-Input" placeholder="例）ポケ鉄" maxLength={6}
                               id={"n"} {...register('n')}/>
                        <span style={{color: "#c85b5b"}} id="ndup" hidden={true}>既に使われています</span>
                    </div>
                    {f}
                </form>
            b=
                <Button variant="primary" type="submit" onClick={() => {
                    let a = {};
                    a["name"] = document.getElementById("n").value;
                    for (let i=2;i<=data.teamSize;i++){
                        a["d"+i] = document.evaluate("/html/body/div/main/form/div["+i+"]/div/div/div[1]/div[1]",document,null, XPathResult.ANY_TYPE, null,).iterateNext().textContent;
                    }
                    entry(a,data.teamSize)
                    handleClose();
                }}>
                    同意してエントリー
                </Button>

        }
        const result = (
            <>
                <p className="text-center">
                    {data.name}
                </p>
                <div className="Form-Item"/>
                <p className="text-center">
                    エントリー数
                </p>
                <p className="text-center">
                    <span className="Form-Item-Input">{data.now}/{data.maxentry}</span>
                </p>
                <div className="Form-Item"/>
                <p className="text-center">
                    ルール
                </p>
                <p className="text-center">
                    {data.description}
                </p>
                <div className="Form-Item"/>
                <p className="text-center">
                    エントリー締切
                </p>
                <p className="text-center">
                    {y}/{M}/{d} {('0' + h).slice(-2)}:{('0' + m).slice(-2)}
                </p>
                {a}
                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>注意事項</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>エントリーは承認制です。<br/>下記の事項に同意の上エントリーしてください。<br/>・複垢参加禁止<br/>・大会ルールを確認する<br/>・礼儀を持って接する<br/>・対戦トラブルを個人間で解決しない</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            キャンセル
                        </Button>
                        {b}
                    </Modal.Footer>
                </Modal>
                <Button variant="primary"
                        style={{marginLeft: "auto", marginRight: "auto", display: "block", marginBottom: "8px"}}
                        value="エントリーする" onClick={handleShow}>エントリーする</Button>
                <Button variant="secondary" style={{marginLeft: "auto", marginRight: "auto", display: "block"}}
                        value="エントリーする" onClick={backHome}>ホームに戻る</Button>
            </>
        )
        if (name == null || data.maxentry <= data.now || data.entry <= Math.floor(new Date().getTime() / 1000)) {
            return (
                <>
                    <p className="text-center">
                        {data.name}
                    </p>
                    <div className="Form-Item"/>
                    <p className="text-center">
                        エントリー数
                    </p>
                    <p className="text-center">
                        <span className="Form-Item-Input">{data.now}/{data.maxentry}</span>
                    </p>
                    <div className="Form-Item"/>
                    <p className="text-center">
                        ルール
                    </p>
                    <p className="text-center">
                        {data.description}
                    </p>
                    <div className="Form-Item"/>
                    <p className="text-center">
                        エントリー締切
                    </p>
                    <p className="text-center">
                        {y}/{M}/{d} {('0' + h).slice(-2)}:{('0' + m).slice(-2)}
                    </p>
                    <div className="Form-Item"/>
                    <p className="text-center">エントリーできません</p>
                </>
            )
        }
        return (
            <>{result}</>
        )
    }
}

function backHome() {
    window.location.href = "/"
}

function entry(da,size) {
    let e = true;
    const entriesRef = doc(db, "entries/" + id + "/entries", name)
    const cityRef = doc(db, 'users/'+email);
    if (da) {
        getDoc(cityRef).then((result) => {
            if (result.data()['entriesTournament'].indexOf(id) !== -1) {
                window.alert("すでにエントリー申請しています。\nホームに戻ります")
                window.location.href = "/"
                e = false;
            }
        })
        if (e) {
            const teamNameRef = collection(db, 'entries/' + id + '/entries');
            const dupRef = query(teamNameRef, where('name', '==', da.name), where('isDeny', '==', false))
            getDocs(dupRef).then((result) => {
                if (result.docs.length !== 0) {
                    document.getElementById("ndup").hidden = false;
                    e = false;
                } else {
                    document.getElementById('ndup').hidden = true;
                    for (let i = 2; i <= size; i++) {
                        const q = query(authUserCollectionRef, where('isVerified', '==', true), where('entriesTournament', 'array-contains', [id]), where('discordId', '==', da["d" + i]));
                        getDocs(q).then((r) => {
                            if (r.docs.length !== 0) {
                                if (e) {
                                    window.alert(i + "人目のユーザーはすでにエントリーしています。")
                                    e = false;
                                }
                            }
                        })
                        if (!e) {
                            break;
                        }
                    }
                }
            })
            if (e){
                for (let x = 2; x <= size; x++) {
                    const z = da["d"+x]
                    const a = query(authUserCollectionRef, where('isVerified', '==', true), where('discordId', '==', z))
                    getDocs(a).then((output) => {
                        const c = output.docs[0].data()["email"];
                        const b = doc(db, "users/" + c)
                        updateDoc(b, {
                            entriesTournament: arrayUnion(id)
                        }).then()
                    })
                }
            }
        }
    }
    if (e){
        getDocs(query(docRef, where('id', '==', id))).then((data) => {
            data.forEach((document) => {
                const path = document._key.path.get(document._key.path.length - 1)
                if (document.data().now >= document.data().maxentry) {
                    window.alert("この大会はエントリー数が枠を超えたため受付を終了しました。")
                } else {
                    const date = Math.floor((new Date().getDate()) / 1000);
                    const userRef = doc(db, 'users/' + email);
                    updateDoc(userRef, {
                            entriesTournament: arrayUnion(id)
                        }
                    ).then();
                    updateDoc(doc(docRef, path), {
                        now: increment(1)
                    }).then()
                    if (da) {
                        let a = [];
                        a.push()
                        for (let i = 2; i <= size; i++) {
                            a.push(da["d" + i]);
                        }
                        setDoc(entriesRef, {
                            name: name,
                            confirmed: false,
                            isDeny: false,
                            registered: false,
                            discord: discord,
                            gameId: gameid,
                            entryDate: date,
                            teamMember: a,
                            gameName: gameName
                        }, {merge: true}).then(() => window.alert("エントリー申請しました"));
                    } else {
                        setDoc(entriesRef, {
                            name: name,
                            confirmed: false,
                            isDeny: false,
                            registered: false,
                            discord: discord,
                            gameId: gameid,
                            entryDate: date,
                            gameName: gameName
                        }, {merge: true}).then(() => window.alert("エントリー申請しました"));
                    }
                }
            })
        })
    }
}

const Tournament = () => {
    return (
        <>
            <Suspense fallback={"loading..."}>
                <SuspendedComponent/>
            </Suspense>
        </>
    );
};
export default Tournament;